import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const ContainerAuthentication = styled(Box)`
  display: flex;
  height: 398px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  width: 100%;

  form {
    width: 361px;
  }
`;

export const TitleAuthentication = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`;

export const TextAuthentication = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;

  text-align: center;
  letter-spacing: 0.15px;
  color: #212121;
`;

export const TextCode = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 17px;
  line-height: 21px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`;

export const CountDown = styled(Box)`
  margin-top: 15px;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 5px;
`;

export const TextCountDown = styled(Typography)`
  font-size: 18px;
`;
